
    var riot = require('riot')
    riot.tag2('treeview', '<div class="{rootNode.mixCss(⁗TreeView⁗)}"> <input type="search" class="{rootNode.mixCss(⁗search⁗)}" if="{inputs.get().search}" placeholder="{inputs.get().labels[⁗search.placeholder⁗]}" oninput="{onSearch}"> <treeviewnode opts="{inputs.get()}" selection="{opts.selection}" model="{inputs.get().sort ? inputs.get().model.sort(inputs.get().sort) : inputs.get().model}" filteredmodel="{filtered}" onselection="{rootNode.onSelect}" dragndrop="{rootNode.wrapDragNDrop()}" ancestors="{[]}" searched="{search.trim()}" depth="{0}"> </TreeViewNode> </div>', '', '', function(opts) {
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _this = this;

var _tools = require("../../tools");

var _core = require("../../core");

var _mixins = require("../mixins");

this.mixin((0, _mixins.optsMixin)());
this.mixin((0, _mixins.listenerMixin)({ eventType: "keyup", callback: function callback(e) {
        return _this.rootNode.onKey(e);
    } }));
this.mixin((0, _mixins.listenerMixin)({ eventType: "keydown", callback: function callback(e) {
        return _this.rootNode.onKey(e);
    } }));

// Logic //

this.filtered = null;
this.search = "";

this.onSearch = function (evt) {
    var input = evt.currentTarget.value;
    _this.search = input;
    _this.filtered = !input.trim() ? null : (0, _tools.tree)(_this.inputs.get().model, _this.inputs.get().category).treeFilter(_this.inputs.get().search(input.trim()));
};

// Boilerplate //

this.inputs = {
    get: function get() {
        return _extends({}, _core.defaults, _this.opts, {
            onSelect: _this.opts.onselection
        });
    }
};
this.outputs = {
    onSelect: this.inputs.get().onselection,
    onDrag: this.inputs.get().dragndrop && this.inputs.get().dragndrop.drag,
    onOver: this.inputs.get().dragndrop && this.inputs.get().dragndrop.over,
    onEnter: this.inputs.get().dragndrop && this.inputs.get().dragndrop.enter,
    onLeave: this.inputs.get().dragndrop && this.inputs.get().dragndrop.leave,
    onDrop: this.inputs.get().dragndrop && this.inputs.get().dragndrop.drop,
    onCancel: this.inputs.get().dragndrop && this.inputs.get().dragndrop.cancel
};
this.state = {
    get: function get() {
        return _extends({}, _this);
    },
    set: function set(s) {
        for (var key in s) {
            if (key in _this) _this[key] = s[key];
        }
    }
};

this.rootNode = new _core.RootNode(this.inputs, this.outputs, this.state, this.update);
});

    
  


//////////////////
// WEBPACK FOOTER
// ./src/riot/components/TreeView.tag
// module id = 13
// module chunks = 0